import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Button, Collapse } from 'react-bootstrap';

import {
  RequisitionNotifications,
  RequisitionNotificationsHelpIcon,
} from '@components/Requisition/RequisitionNotifications';

import './PatientDetailOrderNotifications.scss';

interface PatientDetailOrderNotificationsProps {
  requisitionId: string;
  enabled: boolean;
}

export function PatientDetailOrderNotifications(props: PatientDetailOrderNotificationsProps) {
  const { requisitionId, enabled } = props;
  const [open, setOpen] = useState(false);
  const contentId = `patientDetailOrderNotifications-${requisitionId}`;

  return (
    <RequisitionNotifications
      requisitionId={requisitionId}
      lazy
      enabled={enabled}
      hideUntilReady
      hideHeader
      renderShell={({ children }) => (
        <>
          <hr className='patient-detail-order-content__divider' />
          <div className='patient-detail-order-notifications'>
            <div className='patient-detail-order-notifications__header'>
              <Button
                variant='ghost'
                aria-label={open ? 'Collapse notifications' : 'Expand notifications'}
                aria-expanded={open}
                aria-controls={contentId}
                onClick={() => setOpen(current => !current)}
                className='patient-detail-order-notifications__toggle'
              >
                <FontAwesomeIcon icon={(open ? faChevronUp : faChevronDown) as IconDefinition} fontSize={16} />
              </Button>
              <div className='d-flex align-items-center gap-2'>
                <h3 className='patient-detail-order-notifications__title mb-0'>Notifications</h3>
                <RequisitionNotificationsHelpIcon requisitionId={requisitionId} />
              </div>
            </div>
            <Collapse in={open}>
              <div id={contentId}>
                <div className='patient-detail-order-notifications__body'>{children}</div>
              </div>
            </Collapse>
          </div>
        </>
      )}
    />
  );
}
